import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { COLORS, FONTS, SIZES } from "@/lib/stickerDesign";

export default function TextStyle({ el, patch, applyAll }) {
  const color = el.color || "#000000";
  return (
    <div className="space-y-3" data-testid="text-style">
      <div className="space-y-1"><Label className="text-xs">Font</Label>
        <Select value={el.font || "Arial"} onValueChange={(v) => patch({ font: v })}>
          <SelectTrigger className="h-8" data-testid="el-font-select"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-card">
            {FONTS.map((f) => <SelectItem key={f} value={f} style={{ fontFamily: f }} data-testid={`font-opt-${f.replace(/ /g, "-")}`}>{f}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1"><Label className="text-xs">Text colour</Label>
        <div className="flex items-center gap-1.5 flex-wrap">
          {COLORS.map((c) => (
            <button key={c} type="button" onClick={() => patch({ color: c })} aria-label={c} data-testid={`el-color-${c.slice(1)}`}
              className={`h-6 w-6 rounded-full border transition-transform hover:scale-110 ${color.toLowerCase() === c ? "ring-2 ring-primary ring-offset-1" : ""}`} style={{ background: c }} />
          ))}
          <input type="color" value={color} onChange={(e) => patch({ color: e.target.value })} className="h-7 w-9 cursor-pointer rounded border bg-transparent" data-testid="el-color-picker" />
        </div>
      </div>
      <div className="flex items-center gap-3 flex-wrap">
        <div className="flex gap-1">
          {SIZES.map(([l, s]) => (
            <Button key={l} size="sm" variant={el.size === s ? "default" : "outline"} className="h-7 w-8 px-0" onClick={() => patch({ size: s })} data-testid={`el-size-${l}`}>{l}</Button>
          ))}
        </div>
        <label className="flex items-center gap-2 text-sm"><Checkbox checked={!!el.bold} onCheckedChange={(v) => patch({ bold: !!v })} data-testid="el-bold-check" /> Bold</label>
        <label className="flex items-center gap-2 text-sm"><Checkbox checked={!!el.italic} onCheckedChange={(v) => patch({ italic: !!v })} data-testid="el-italic-check" /> Italic</label>
      </div>
      <Button size="sm" variant="outline" className="w-full" onClick={() => applyAll({ font: el.font || "Arial", color })} data-testid="el-apply-all">Use this font & colour on all lines</Button>
    </div>
  );
}
